import Vue from 'vue'
import Router from 'vue-router'
import HomeBase from '@/components/home/HomeBase'
import HomeIndex from '@/components/home/index/Index'
import HomeMap from '@/components/home/map/Map'
import HomeDocument from '@/components/home/article/Document'
import HomeArticleclass from '@/components/home/article/Articleclass'
import HomeArticlelist from '@/components/home/article/Articlelist'
import HomeArticlefind from '@/components/home/articlefind/Search'
import HomeArticledetail from '@/components/home/article/Articledetail'
import ArticledetailWx from '@/components/home/article/ArticledetailWx'
import HomeMemberLogin from '@/components/home/memberlogin/Login'
import miniapplogin from '@/components/home/memberlogin/Loginminiapp'
import HomeMemberForget from '@/components/home/memberforget/Forget'
import HomeMemberRegister from '@/components/home/memberregister/Register'
import HomeMemberBind from '@/components/home/memberbind/Bind'
import HomeGoodsclass from '@/components/home/goodsclass/Goodsclass'
import HomeBrand from '@/components/home/brand/Brand'
import HomeSearch from '@/components/home/search/Search'
import HomeCart from '@/components/home/cart/Cart'
import HomeStoreVoucher from '@/components/home/storedetail/StoreVoucher'
import HomeGoodslist from '@/components/home/goodslist/Goodslist'
import HomeGoodsdetail from '@/components/home/goodsdetail/Goodsdetail'

import HomeGoodsConsult from '@/components/home/goodsdetail/GoodsConsult'
import HomePointsgoods from '@/components/home/pointsgoods/Index'
import HomePointsgoodsDetail from '@/components/home/pointsgoods/Detail'
import HomePintuanList from '@/components/home/pintuan/PintuanList'
import HomeMarketcard from '@/components/home/marketmanage/Marketcard'
import HomeMarketzodiac from '@/components/home/marketmanage/Marketzodiac'
import HomeMarketwheel from '@/components/home/marketmanage/Marketwheel'
import HomeMarketegg from '@/components/home/marketmanage/Marketegg'
import HomeBonusDetail from '@/components/home/bonus/Detail'
import HomeGroupBuyList from '@/components/home/groupbuy/GroupBuyList'
import HomeVrGroupBuyList from '@/components/home/vrgroupbuy/GroupBuyList'
import MemberBase from '@/components/member/MemberBase'
import MemberIndex from '@/components/member/index/Index'
import MemberAccount from '@/components/member/account/Account'
import MemberOrderreturn from '@/components/member/orderreturn/Orderreturn'
import MemberAddressList from '@/components/member/address/AddressList'
import MemberAddressForm from '@/components/member/address/AddressForm'
import MemberBankList from '@/components/member/bank/BankList'
import MemberBankForm from '@/components/member/bank/BankForm'
import MemberConsultList from '@/components/member/consult/ConsultList'
import MemberFriendList from '@/components/member/friend/FriendList'
import MemberRefundList from '@/components/member/refund/RefundList'
import MemberRefundForm from '@/components/member/refund/RefundForm'
import MemberRefundView from '@/components/member/refund/RefundView'
import MemberVrRefundList from '@/components/member/vrrefund/VrRefundList'
import MemberVrRefundForm from '@/components/member/vrrefund/VrRefundForm'
import MemberVrRefundView from '@/components/member/vrrefund/VrRefundView'
import MemberReturnList from '@/components/member/return/ReturnList'
import MemberReturnForm from '@/components/member/return/ReturnForm'
import MemberReturnView from '@/components/member/return/ReturnView'
import MemberReturnSend from '@/components/member/return/ReturnSend'
import MemberInvoiceList from '@/components/member/invoice/InvoiceList'
import MemberInvoiceForm from '@/components/member/invoice/InvoiceForm'
import MemberBuyStep1 from '@/components/member/buy/step1'
import MemberVrBuyStep1 from '@/components/member/vrbuy/step1'
import MemberPointsCart from '@/components/member/pointscart/Cart'
import MemberPointsBuyStep1 from '@/components/member/pointsbuy/step1'
import MemberPointsOrderList from '@/components/member/pointsorder/OrderList'
import MemberPointsOrderDetail from '@/components/member/pointsorder/OrderDetail'
import MemberInformList from '@/components/member/inform/InformList'
import MemberInformForm from '@/components/member/inform/InformForm'
import MemberBuyPay from '@/components/member/buy/pay'
import MemberFavorite from '@/components/member/favorite/Favorite'
import MemberOrderList from '@/components/member/order/OrderList'
import MemberOrderDetail from '@/components/member/order/OrderDetail'
import MemberOrderDeliver from '@/components/member/order/OrderDeliver'
import MemberOrderEvaluate from '@/components/member/order/OrderEvaluate'

import MemberVrOrderList from '@/components/member/vrorder/OrderList'
import MemberVrOrderDetail from '@/components/member/vrorder/OrderDetail'
import MemberVrOrderEvaluate from '@/components/member/vrorder/OrderEvaluate'

import MemberPredepositList from '@/components/member/predeposit/PredepositList'
import MemberRechargeCardList from '@/components/member/predeposit/RechargeCardList'
import MemberWithdrawList from '@/components/member/withdraw/WithdrawList'
import MemberRechargeList from '@/components/member/recharge/RechargeList'
import MemberVoucherList from '@/components/member/voucher/VoucherList'
import MemberNoticeList from '@/components/member/notice/NoticeList'
import MemberSetting from '@/components/member/setting/AccountSet'
import MemberProfileSet from '@/components/member/profile/ProfileSet'
import MemberPointList from '@/components/member/point/PointList'
import MemberPointSignin from '@/components/member/point/PointSignin'
import MemberEvaluateList from '@/components/member/evaluate/EvaluateList'
import MemberInviterManage from '@/components/member/inviter/InviterManage'
import MemberInviterUser from '@/components/member/inviter/InviterUser'
import MemberInviterOrder from '@/components/member/inviter/InviterOrder'
import MemberMarketmanagelog from '@/components/member/marketmanagelog/Marketmanagelog'
import MemberBonusreceive from '@/components/member/bonusreceive/Bonusreceive'
import MemberArrivalnotice from '@/components/member/arrivalnotice/Arrivalnotice'
import MemberAuth from '@/components/member/auth/Auth'
import MemberGas from '@/components/member/gas/gas'
import MemberInsurance from '@/components/member/gas/insurance'
import MemberInsuranceList from '@/components/member/gas/list'
import InsuranceDetail from '@/components/member/gas/detail'
import MemberBrowseList from '@/components/member/browse/BrowseList'
import MemberFeedback from '@/components/member/feedback/Feedback'
Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '',
      redirect: '/home/index',
      meta: {
        footer: {
          show: true
        }
      }
    },
    {
      path: '/home/',
      component: HomeBase,
      children: [
        // 首页
        { path: 'index', name: 'HomeIndex', component: HomeIndex, meta: { footer: { show: true } } },
        // 地图
        { path: 'map', name: 'HomeMap', component: HomeMap, meta: { footer: { show: true } } },
        // 注册协议
        { path: 'document', name: 'HomeDocument', component: HomeDocument, meta: { footer: { show: true } } },
        // 文章分类
        { path: 'article_class', name: 'HomeArticleclass', component: HomeArticleclass, meta: { footer: { show: true } } },
        // 文章列表
        { path: 'article_list', name: 'HomeArticlelist', component: HomeArticlelist, meta: { footer: { show: true } } },
        // 文章详情
        { path: 'article_detail', name: 'HomeArticledetail', component: HomeArticledetail, meta: { footer: { show: true } } },
        { path: 'article_detail_wx', name: 'ArticledetailWx', component: ArticledetailWx, meta: { footer: { show: true } } },
        // 用户注册
        { path: 'memberregister', name: 'HomeMemberRegister', component: HomeMemberRegister, meta: { footer: { show: true } } },
        // 用户绑定
        { path: 'memberbind', name: 'HomeMemberBind', component: HomeMemberBind, meta: { footer: { show: true } } },
        // 用户登录
        { path: 'memberlogin', name: 'HomeMemberLogin', component: HomeMemberLogin, meta: { footer: { show: true } } },
        { path: 'miniapplogin', name: 'miniapplogin', component: miniapplogin, meta: { footer: { show: true } } },
        // 忘记密码
        { path: 'memberforget', name: 'HomeMemberForget', component: HomeMemberForget, meta: { footer: { show: true } } },
        // 分类
        { path: 'goodsclass', name: 'HomeGoodsclass', component: HomeGoodsclass, meta: { footer: { show: true } } },
        // 品牌
        { path: 'brand', name: 'HomeBrand', component: HomeBrand, meta: { footer: { show: true } } },
        // 购物车
        { path: 'cart', name: 'HomeCart', component: HomeCart, meta: { footer: { show: true } } },
        // 搜索
        { path: 'search', name: 'HomeSearch', component: HomeSearch, meta: { footer: { show: true } } },
        { path: 'HomeArticlefind', name: 'HomeArticlefind', component: HomeArticlefind, meta: { footer: { show: true } } },
        // 店铺代金券
        { path: 'storevoucher', name: 'HomeStoreVoucher', component: HomeStoreVoucher, meta: { footer: { show: false } } },
        // 店铺列表
        { path: 'goodslist', name: 'HomeGoodslist', component: HomeGoodslist, meta: { footer: { show: true } } },
        // 商品详情
        { path: 'goodsdetail', name: 'HomeGoodsdetail', component: HomeGoodsdetail, meta: { footer: { show: false } } },
        // 商品咨询
        { path: 'goodsconsult', name: 'HomeGoodsConsult', component: HomeGoodsConsult, meta: { footer: { show: false } } },
        // 拼团列表
        { path: 'pintuan_list', name: 'HomePintuanList', component: HomePintuanList, meta: { footer: { show: true } } },
        // 积分兑换商品
        { path: 'pointsgoods', name: 'HomePointsgoods', component: HomePointsgoods, meta: { footer: { show: true } } },
        // 积分兑换商品详情页
        { path: 'pointsgoods_detail', name: 'HomePointsgoodsDetail', component: HomePointsgoodsDetail, meta: { footer: { show: false } } },
        // 红包兑换商品详情页
        { path: 'bonus_detail', name: 'HomeBonusDetail', component: HomeBonusDetail, meta: { footer: { show: false } } },
        // 刮刮卡
        { path: 'marketcard', name: 'HomeMarketcard', component: HomeMarketcard, meta: { footer: { show: false } } },
        // 生肖翻翻看
        { path: 'marketzodiac', name: 'HomeMarketzodiac', component: HomeMarketzodiac, meta: { footer: { show: false } } },
        // 大转盘
        { path: 'marketwheel', name: 'HomeMarketwheel', component: HomeMarketwheel, meta: { footer: { show: false } } },
        // 砸金蛋
        { path: 'marketegg', name: 'HomeMarketegg', component: HomeMarketegg, meta: { footer: { show: false } } },
        // 抢购列表
        { path: 'groupbuy_list', name: 'HomeGroupBuyList', component: HomeGroupBuyList, meta: { footer: { show: false } } },
        // 虚拟抢购列表
        { path: 'vr_groupbuy_list', name: 'HomeVrGroupBuyList', component: HomeVrGroupBuyList, meta: { footer: { show: false } } }
      ]
    },

    {
      path: '/member/',
      component: MemberBase,
      children: [
        // 用户中心
        { path: 'index', name: 'MemberIndex', component: MemberIndex, meta: { footer: { show: true } } },
        // 我的钱包
        { path: 'account', name: 'MemberAccount', component: MemberAccount, meta: { footer: { show: true } } },
        // 退款退货
        { path: 'orderreturn', name: 'MemberOrderreturn', component: MemberOrderreturn, meta: { footer: { show: true } } },
        // 资金明细
        { path: 'predeposit_list', name: 'MemberPredepositList', component: MemberPredepositList, meta: { footer: { show: true } } },
        // 充值卡明细
        { path: 'recharge_card_list', name: 'MemberRechargeCardList', component: MemberRechargeCardList, meta: { footer: { show: true } } },
        // 提现明细
        { path: 'withdraw_list', name: 'MemberWithdrawList', component: MemberWithdrawList, meta: { footer: { show: true } } },
        // 好友列表
        { path: 'friend_list', name: 'MemberFriendList', component: MemberFriendList, meta: { footer: { show: false } } },
        // 咨询列表
        { path: 'consult_list', name: 'MemberConsultList', component: MemberConsultList, meta: { footer: { show: true } } },
        // 充值明细
        { path: 'recharge_list', name: 'MemberRechargeList', component: MemberRechargeList, meta: { footer: { show: true } } },
        // 代金券列表
        { path: 'voucher_list', name: 'MemberVoucherList', component: MemberVoucherList, meta: { footer: { show: true } } },
        // 消息列表
        { path: 'notice_list', name: 'MemberNoticeList', component: MemberNoticeList, meta: { footer: { show: true } } },
        // 账号设置
        { path: 'setting', name: 'MemberSetting', component: MemberSetting, meta: { footer: { show: true } } },
        // 个人信息
        { path: 'profile_set', name: 'MemberProfileSet', component: MemberProfileSet, meta: { footer: { show: true } } },
        // 积分明细
        { path: 'point_list', name: 'MemberPointList', component: MemberPointList, meta: { footer: { show: true } } },
        // 签到送积分
        { path: 'point_signin', name: 'MemberPointSignin', component: MemberPointSignin, meta: { footer: { show: true } } },
        // 地址列表
        { path: 'address_list', name: 'MemberAddressList', component: MemberAddressList, meta: { footer: { show: true } } },
        // 地址编辑
        { path: 'address_form', name: 'MemberAddressForm', component: MemberAddressForm, meta: { footer: { show: true } } },
          // 提现账户列表
          { path: 'bank_list', name: 'MemberBankList', component: MemberBankList, meta: { footer: { show: true } } },
          // 提现账户编辑
          { path: 'bank_form', name: 'MemberBankForm', component: MemberBankForm, meta: { footer: { show: true } } },
        // 退款列表
        { path: 'refund_list', name: 'MemberRefundList', component: MemberRefundList, meta: { footer: { show: true } } },
        // 退款编辑
        { path: 'refund_form', name: 'MemberRefundForm', component: MemberRefundForm, meta: { footer: { show: true } } },
        // 退款详情
        { path: 'refund_view', name: 'MemberRefundView', component: MemberRefundView, meta: { footer: { show: true } } },
        // 退款列表
        { path: 'vrrefund_list', name: 'MemberVrRefundList', component: MemberVrRefundList, meta: { footer: { show: true } } },
        // 退款编辑
        { path: 'vrrefund_form', name: 'MemberVrRefundForm', component: MemberVrRefundForm, meta: { footer: { show: true } } },
        // 退款详情
        { path: 'vrrefund_view', name: 'MemberVrRefundView', component: MemberVrRefundView, meta: { footer: { show: true } } },
        // 退货列表
        { path: 'return_list', name: 'MemberReturnList', component: MemberReturnList, meta: { footer: { show: true } } },
        // 退货编辑
        { path: 'return_form', name: 'MemberReturnForm', component: MemberReturnForm, meta: { footer: { show: true } } },
        // 退货详情
        { path: 'return_view', name: 'MemberReturnView', component: MemberReturnView, meta: { footer: { show: true } } },
        // 退货
        { path: 'return_send', name: 'MemberReturnSend', component: MemberReturnSend, meta: { footer: { show: true } } },
        // 发票列表
        { path: 'invoice_list', name: 'MemberInvoiceList', component: MemberInvoiceList, meta: { footer: { show: true } } },
        // 发票编辑
        { path: 'invoice_form', name: 'MemberInvoiceForm', component: MemberInvoiceForm, meta: { footer: { show: true } } },
        // 下单界面
        { path: 'buystep1', name: 'MemberBuyStep1', component: MemberBuyStep1, meta: { footer: { show: false } } },
        // 下单界面
        { path: 'vrbuystep1', name: 'MemberVrBuyStep1', component: MemberVrBuyStep1, meta: { footer: { show: false } } },
        // 积分商品下单
        { path: 'pointsbuystep1', name: 'MemberPointsBuyStep1', component: MemberPointsBuyStep1, meta: { footer: { show: false } } },
        // 积分商品购物车
        { path: 'pointscart', name: 'MemberPointsCart', component: MemberPointsCart, meta: { footer: { show: true } } },
        // 积分订单列表
        { path: 'pointsorder_list', name: 'MemberPointsOrderList', component: MemberPointsOrderList, meta: { footer: { show: true } } },
        // 积分订单详情
        { path: 'pointsorder_detail', name: 'MemberPointsOrderDetail', component: MemberPointsOrderDetail, meta: { footer: { show: true } } },
        // 商家投诉
        { path: 'inform_list', name: 'MemberInformList', component: MemberInformList, meta: { footer: { show: true } } },
        // 商家投诉
        { path: 'inform_form', name: 'MemberInformForm', component: MemberInformForm, meta: { footer: { show: true } } },
        // 支付界面
        { path: 'buypay', name: 'MemberBuyPay', component: MemberBuyPay, meta: { footer: { show: false } } },
        // 我的订单
        { path: 'order_list', name: 'MemberOrderList', component: MemberOrderList, meta: { footer: { show: true } } },
        // 我的收藏
        { path: 'favorite', name: 'MemberFavorite', component: MemberFavorite, meta: { footer: { show: true } } },
        // 订单详情
        { path: 'order_detail', name: 'MemberOrderDetail', component: MemberOrderDetail, meta: { footer: { show: true } } },
        // 物流跟踪
        { path: 'order_deliver', name: 'MemberOrderDeliver', component: MemberOrderDeliver, meta: { footer: { show: true } } },
        // 评价订单
        { path: 'order_evaluate', name: 'MemberOrderEvaluate', component: MemberOrderEvaluate, meta: { footer: { show: true } } },
        // 订单详情
        { path: 'vrorder_detail', name: 'MemberVrOrderDetail', component: MemberVrOrderDetail, meta: { footer: { show: true } } },
        // 评价订单
        { path: 'vrorder_evaluate', name: 'MemberVrOrderEvaluate', component: MemberVrOrderEvaluate, meta: { footer: { show: true } } },
        // 我的订单
        { path: 'vrorder_list', name: 'MemberVrOrderList', component: MemberVrOrderList, meta: { footer: { show: true } } },

        // 用户订单评价列表
        { path: 'evaluate_list', name: 'MemberEvaluateList', component: MemberEvaluateList, meta: { footer: { show: true } } },
        // 推广海报
        { path: 'inviter_manage', name: 'MemberInviterManage', component: MemberInviterManage, meta: { footer: { show: true } } },
        // 推广会员
        { path: 'inviter_user', name: 'MemberInviterUser', component: MemberInviterUser, meta: { footer: { show: true } } },
        // 推广佣金
        { path: 'inviter_order', name: 'MemberInviterOrder', component: MemberInviterOrder, meta: { footer: { show: true } } },
        // 活动记录
        { path: 'marketmanagelog', name: 'MemberMarketmanagelog', component: MemberMarketmanagelog, meta: { footer: { show: true } } },
        // 红包领取记录
        { path: 'bonusreceive', name: 'MemberBonusreceive', component: MemberBonusreceive, meta: { footer: { show: true } } },
        // 到货通知页面
        { path: 'arrivalnotice', name: 'MemberArrivalnotice', component: MemberArrivalnotice, meta: { footer: { show: true } } },
        // 浏览历史页面
        { path: 'browse_list', name: 'MemberBrowseList', component: MemberBrowseList, meta: { footer: { show: true } } },
        // 意见反馈
        { path: 'feedback', name: 'MemberFeedback', component: MemberFeedback, meta: { footer: { show: true } } },
        // 会员认证页面
        { path: 'auth', name: 'MemberAuth', component: MemberAuth, meta: { footer: { show: true } } },
        // 燃气用户页面
        { path: 'gas', name: 'MemberGas', component: MemberGas, meta: { footer: { show: true } } },
        // 保险购买页面
        { path: 'insurance', name: 'MemberInsurance', component: MemberInsurance, meta: { footer: { show: false } } },
        { path: 'InsuranceDetail', name: 'InsuranceDetail', component: InsuranceDetail, meta: { footer: { show: false } } },
        { path: 'list', name: 'MemberInsuranceList', component: MemberInsuranceList, meta: { footer: { show: false } } }
      ]
    }

  ]
})
